/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_User_AriaInputs */



/**
* | output |
* | --- |
* | "Select user to manage" |
*
* @param {Team_Manager_Select_User_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_user_aria = /** @type {((inputs?: Team_Manager_Select_User_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_User_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner l’utilisateur à gérer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie den zu verwaltenden Benutzer aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'utente da gestire")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите пользователя для управления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el usuario a administrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要管理的用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("管理するユーザーを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रबंधित करने के लिए उपयोगकर्ता का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o usuário a ser gerenciado")
	return /** @type {LocalizedString} */ ("Select user to manage")
});